import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "gramps-stronggrstrongaphql-strongastrongpollo-strongmstrongicroservice-strongpstrongattern-strongsstrongerver"
    }}>{`GrAMPS (`}<strong>{`Gr`}</strong>{`aphQL `}<strong>{`A`}</strong>{`pollo `}<strong>{`M`}</strong>{`icroservice `}<strong>{`P`}</strong>{`attern `}<strong>{`S`}</strong>{`erver)`}</h3>
    <PageDescription mdxType="PageDescription">
      <p>{`A thin layer of helper tools designed for the `}<a parentName="p" {...{
          "href": "https://www.apollographql.com/docs/apollo-server/"
        }}>{`Apollo GraphQL server`}</a>{` that allows independent data sources — a schema, resolvers, and data access model — to be composed into a single GraphQL schema, while keeping the code within each data source isolated, independently testable, and completely decoupled from the rest of your application.`}</p>
    </PageDescription>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      